import deprecatedRoutes from '@/deprecated-routes.js'

export default {
  routes: [
    ...deprecatedRoutes,

    {
      path: '/',
      name: 'home',
      redirect: {
        name: 'selectLocation',
      },
    },

    {
      path: '/send-storage-data',
      name: 'sendStorageData',
    },

    {
      path: '/intro',
      name: 'intro',
      component: () => import('@/pages/Intro.vue'),
    },

    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/pages/Contact.vue'),
      children: [
        {
          path: 'chat',
          name: 'contactChat',
        },

        {
          path: 'feedback',
          name: 'feedback',
          component: () => import('@/pages/Contact/Feedback.vue'),
          props: true,
        },
      ],
    },

    {
      path: '/login',
      name: 'login',
      props: true,
      component: () => import('@/pages/User/Login.vue'),
    },

    {
      path: '/login/resgatar-senha',
      name: 'redeemPassword',
      props: true,
      component: () => import('@/pages/User/Login.vue'),
    },

    {
      path: '/register',
      name: 'register',
      props: true,
      component: () => import('@/pages/User/Register.vue'),
    },

    {
      path: '/my-location',
      name: 'selectLocation',
      component: () => import('@/pages/SelectLocation.vue'),
      props: true,
      children: [
        {
          path: ':cityId',
          name: 'selectCompany',
          component: () => import('@/pages/SelectCompany.vue'),
          props: true,
          children: [
            {
              path: 'search',
              name: 'search',
              props: true,
              component: () => import('@/pages/City/Search.vue'),
            },

            {
              path: 'filters',
              name: 'selectCompanyFilters',
              props: true,
            },

            {
              path: 'groups/:companiesGroupId',
              name: 'companiesGroup',
              component: () => import('@/pages/City/CompaniesGroup.vue'),
              props: true,
            },

            {
              path: 'companies/:companyId',
              name: 'company',
              component: () => import('@/pages/Company.vue'),
              props: true,
              redirect: to => ({
                ...to,
                name: 'companyMenu',
                params: {
                  ...to.params,
                  companyId: to.params.companyId ?? to.params.establishmentId,
                },
              }),
              children: [
                {
                  path: 'sections',
                  alias: 'menu',
                  name: 'companyMenu',
                  component: () => import('@/pages/Company/Menu.vue'),
                  props: true,
                  children: [
                    {
                      path: ':sectionId',
                      name: 'companySection',
                      component: () =>
                        import('@/pages/Company/Menu/Section.vue'),
                      props: true,
                      meta: {
                        standalone: true,
                      },
                    },
                  ],
                },

                {
                  path: 'info',
                  name: 'companyInfo',
                  component: () => import('@/pages/Company/Info.vue'),
                  props: true,
                },

                {
                  path: 'ratings',
                  name: 'companyRatings',
                  component: () => import('@/pages/Company/Ratings.vue'),
                  props: true,
                  children: [
                    {
                      path: 'new',
                      name: 'companyNewRating',
                      props: true,
                    },

                    {
                      path: ':ratingId',
                      name: 'companyRating',
                      props: true,
                    },
                  ],
                },

                {
                  path: 'opening-hours',
                  name: 'companyOpeningHours',
                  component: () => import('@/pages/Company/OpeningHours.vue'),
                  props: true,
                },

                {
                  path: 'location',
                  name: 'companyLocation',
                  component: () => import('@/pages/Company/Location.vue'),
                  props: true,
                },

                {
                  path: 'payment-forms',
                  name: 'companyPaymentForms',
                  component: () => import('@/pages/Company/PaymentForms.vue'),
                  props: true,
                },

                {
                  path: 'checkout',
                  name: 'companyCheckout',
                  component: () => import('@/pages/Company/Checkout.vue'),
                  props: true,
                  redirect: {
                    name: 'companyCheckoutPaymentForm',
                  },
                  children: [
                    {
                      path: 'cart',
                      name: 'companyCart',
                      component: () =>
                        import('@/pages/Company/Checkout/Cart.vue'),
                      props: true,
                      meta: {
                        standalone: true,
                      },
                    },

                    {
                      path: 'payment-form',
                      name: 'companyCheckoutPaymentForm',
                      component: () =>
                        import('@/pages/Company/Checkout/PaymentForm.vue'),
                      props: true,
                      meta: {
                        standalone: true,
                      },
                    },

                    {
                      path: 'additions',
                      name: 'CompanyCheckoutAdditions',
                      component: () =>
                        import('@/pages/Company/Checkout/Additions.vue'),
                      props: true,
                      meta: {
                        standalone: true,
                      },
                    },

                    {
                      path: 'review',
                      name: 'companyCheckoutReview',
                      component: () =>
                        import('@/pages/Company/Checkout/Review.vue'),
                      props: true,
                      meta: {
                        standalone: true,
                      },
                    },

                    {
                      path: 'finish',
                      name: 'companyCheckoutFinish',
                      component: () =>
                        import('@/pages/Company/Checkout/Finish.vue'),
                      props: true,
                      meta: {
                        standalone: true,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },

    {
      path: '/user',
      props: true,
      component: () => import('@/components/RouteView.vue'),
      children: [
        {
          path: 'password-reset/:token',
          name: 'userPasswordReset',
          component: () => import('@/pages/User/PasswordReset.vue'),
          props: true,
        },
      ],
    },

    {
      path: '/me/make-delivery',
      name: 'userMakeDelivery',
      component: () => import('@/pages/User/MakeDelivery.vue'),
      children: [
        {
          path: ':orderId',
          name: 'userMakeDeliveryTrack',
          props: true,
          component: () => import('@/pages/User/MakeDelivery/Track.vue'),
        },
      ],
    },

    {
      path: '/me/notifications',
      name: 'userNotifications',
      component: () => import('@/pages/User/Notifications.vue'),
    },

    {
      path: '/me/retrospective/:year',
      name: 'userRetrospective',
      component: () => import('@/pages/User/Retrospective.vue'),
      props: true,
    },

    {
      path: '/me/points',
      name: 'userPoints',
      redirect: {
        name: 'userCashback',
      },
    },

    {
      path: '/me/cashback',
      name: 'userCashback',
      redirect: {
        name: 'userCashbackSummary',
      },
      component: () => import('@/pages/User/Cashback.vue'),
      props: true,
      children: [
        {
          path: 'summary',
          name: 'userCashbackSummary',
          component: () => import('@/pages/User/Cashback/Summary.vue'),
          props: true,
        },

        {
          path: 'transactions',
          name: 'userCashbackTransactions',
          component: () => import('@/pages/User/Cashback/Transactions.vue'),
          props: true,
        },

        {
          path: 'transfer',
          name: 'userCashbackTransfer',
          component: () => import('@/pages/User/Cashback/Transfer.vue'),
          props: true,
        },
      ],
    },

    {
      path: '/me/orders',
      name: 'userOrders',
      component: () => import('@/pages/User/Orders.vue'),
      props: true,
      children: [
        {
          path: ':orderId',
          name: 'userOrderDetail',
          component: () => import('@/pages/User/Orders/Detail.vue'),
          props: true,
          children: [
            {
              path: 'location',
              name: 'userOrderLocation',
              component: () => import('@/pages/User/Orders/Location.vue'),
              props: true,
            },
          ],
        },
      ],
    },

    {
      path: '/me/account-deletion',
      name: 'accountDeletion',
      component: () => import('@/pages/User/AccountDeletion.vue'),
      redirect: {
        name: 'home',
      },
    },

    {
      path: '/me/settings',
      name: 'userSettings',
      component: () => import('@/pages/User/Settings.vue'),
      props: true,
      children: [
        {
          path: 'profile/edit',
          name: 'userProfileEdit',
          component: () => import('@/pages/User/Settings/ProfileEdit.vue'),
        },

        {
          path: 'notifications',
          name: 'userSettingsNotifications',
          props: true,
          component: () => import('@/pages/User/Settings/Notifications.vue'),
        },

        {
          path: 'adresses',
          name: 'userAdresses',
          component: () => import('@/pages/User/Settings/Adresses.vue'),
          props: true,
          children: [
            {
              path: 'new',
              name: 'newUserAddress',
              component: () =>
                import('@/pages/User/Settings/Adresses/Address.vue'),
              props: true,
            },

            {
              path: ':addressId/edit',
              name: 'editUserAddress',
              component: () =>
                import('@/pages/User/Settings/Adresses/Address.vue'),
              props: true,
            },
          ],
        },

        {
          path: 'payment-cards',
          name: 'paymentCards',
          component: () => import('@/pages/User/Settings/PaymentCards.vue'),
          props: true,
          children: [
            {
              path: 'select',
              name: 'selectPaymentCard',
              component: () => import('@/pages/User/Settings/PaymentCards.vue'),
              props: true,
            },

            {
              path: 'new',
              name: 'addPaymentCard',
              component: () =>
                import('@/pages/User/Settings/PaymentCards/PaymentCard.vue'),
              props: true,
            },

            {
              path: ':paymentCardId/edit',
              name: 'editPaymentCard',
              component: () =>
                import('@/pages/User/Settings/PaymentCards/PaymentCard.vue'),
              props: true,
            },
          ],
        },
      ],
    },

    {
      path: '/me/affiliates',
      name: 'userAffiliates',
      component: () => import('@/pages/User/Affiliates.vue'),
      props: true,
      redirect: {
        name: 'affiliatesIndication',
      },
      children: [
        {
          path: 'indication',
          name: 'affiliatesIndication',
          component: () => import('@/pages/User/Affiliates/Indication.vue'),
          props: true,
        },
        {
          path: 'list',
          name: 'affiliatesList',
          component: () => import('@/pages/User/Affiliates/List.vue'),
          props: true,
        },
      ],
    },

    {
      path: '*',
      redirect: '/',
    },
  ],
}
